import {createReducer, on} from '@ngrx/store';

import {
  BuildKitSettingTemplate,
} from "../../../shared/models/build-kit.model";
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  addBuildKitSettingTemplate, addBuildKitSettingTemplateFailure,
  addBuildKitSettingTemplateSuccess,
  loadBuildKitSettingTemplates,
  loadBuildKitSettingTemplatesFailure,
  loadBuildKitSettingTemplatesSuccess,
  modifyBuildKitSettingTemplate,
  modifyBuildKitSettingTemplateFailure,
  modifyBuildKitSettingTemplateSuccess,
  removeBuildKitSettingTemplate, removeBuildKitSettingTemplateFailure, removeBuildKitSettingTemplateSuccess,
  setSelectedBuildKitSettingTemplate,
  setSelectedBuildKitSettingTemplateSuccess
} from "./build-kit-setting-template.action";


export interface BuildKitSettingTemplateState {
  buildKitSettingTemplates: BuildKitSettingTemplate[];
  selectedBuildKitSettingTemplate: BuildKitSettingTemplate | null;
  error: string | null;
  buildKitSettingTemplateStatus: StateStatus;
}

export const initialState: BuildKitSettingTemplateState = {
  buildKitSettingTemplates: [],
  selectedBuildKitSettingTemplate: null,
  buildKitSettingTemplateStatus: 'pending',
  error: null

};

export const buildKitSettingTemplateReducer = createReducer(
  initialState,
  on(loadBuildKitSettingTemplates, (state): BuildKitSettingTemplateState =>
    ({ ...state, buildKitSettingTemplateStatus: 'loading' as StateStatus })),
  on(loadBuildKitSettingTemplatesSuccess, (state, { buildKitSettingTemplates }): BuildKitSettingTemplateState => ({
    ...state,
    buildKitSettingTemplates: buildKitSettingTemplates,
    error: null,
    buildKitSettingTemplateStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadBuildKitSettingTemplatesFailure, (state, { error }): BuildKitSettingTemplateState => ({
    ...state,
    error: error,
    buildKitSettingTemplateStatus: 'error' as StateStatus,
  })),
  on(setSelectedBuildKitSettingTemplateSuccess, (state, { selectedBuildKitSettingTemplate }): BuildKitSettingTemplateState => ({
    ...state,
    selectedBuildKitSettingTemplate: selectedBuildKitSettingTemplate
  })),

  on(addBuildKitSettingTemplate, (state, { buildKitSettingTemplate }): BuildKitSettingTemplateState => ({
    ...state,
    buildKitSettingTemplateStatus: 'adding' as StateStatus,
  })),
  on(addBuildKitSettingTemplateSuccess, (state, { buildKitSettingTemplate }): BuildKitSettingTemplateState => ({
    ...state,
    buildKitSettingTemplateStatus: 'addSuccess' as StateStatus,
    buildKitSettingTemplates: [
      buildKitSettingTemplate,
      ...state.buildKitSettingTemplates
    ]
  })),
  on(addBuildKitSettingTemplateFailure, (state, { error }): BuildKitSettingTemplateState => ({
    ...state,
    error: error,
    buildKitSettingTemplateStatus: 'error' as StateStatus,
  })),


  on(modifyBuildKitSettingTemplate, (state, { buildKitSettingTemplate }): BuildKitSettingTemplateState => ({
    ...state,
    buildKitSettingTemplateStatus: 'modifying' as StateStatus,
  })),

  on(modifyBuildKitSettingTemplateSuccess, (state, {buildKitSettingTemplate}): BuildKitSettingTemplateState => ({
    ...state,
    // buildKitSettingTemplates: state.buildKitSettingTemplates.map(originalTemplate => {
    //   return originalTemplate.id == buildKitSettingTemplate.id ? buildKitSettingTemplate : originalTemplate;
    // }),
    error: null,
    buildKitSettingTemplateStatus: 'saveSuccess' as StateStatus,
  })),
  on(modifyBuildKitSettingTemplateFailure, (state, { error }): BuildKitSettingTemplateState => ({
    ...state,
    error: error,
    buildKitSettingTemplateStatus: 'error' as StateStatus,
  })),

  on(removeBuildKitSettingTemplate, (state, { buildKitSettingTemplateId }):BuildKitSettingTemplateState => ({
    ...state,
    buildKitSettingTemplateStatus: 'removing' as StateStatus
  })),

  on(removeBuildKitSettingTemplateSuccess, (state, { buildKitSettingTemplateId }): BuildKitSettingTemplateState => ({
    ...state,
    buildKitSettingTemplates: state.buildKitSettingTemplates.filter((x) => x.id !== buildKitSettingTemplateId),
    error: null,
    buildKitSettingTemplateStatus: 'removeSuccess' as StateStatus,
  })),
  on(removeBuildKitSettingTemplateFailure, (state, { error }): BuildKitSettingTemplateState => ({
    ...state,
    error: error,
    buildKitSettingTemplateStatus: 'error' as StateStatus,
  })),
);

